module.exports = _.reduce;